import { boot } from "quasar/wrappers";
import formatDate from "src/filters/formatDate";
import formatPhone from "src/filters/formatPhone";
import formatNumber from "src/filters/formatNumber";
import formatLevelImage from "src/filters/formatLevelImage";
import { Platform } from "quasar";
import { reloadPage } from "src/utils";

export default boot(({ app, router }) => {
  app.provide("formatDate", formatDate);
  app.provide("formatPhone", formatPhone);
  app.provide("formatNumber", formatNumber);
  app.provide("formatLevelImage", formatLevelImage);

  window.handleOpenURL = (url) => {
    try {
      if (Platform.is.cordova && Platform.is.android) {
        let splitUrl = url.split("://");
        if (!splitUrl[1]) reloadPage();
        let callbackParams = splitUrl[1]
          .replace(/^store-detail\/+/i, "")
          .split("?");
        let params = new URLSearchParams(callbackParams[1]),
          storeID = callbackParams[0];
        // console.log("storeID", splitUrl, params);
        if (storeID && params.get("sessionId")) {
          router.push({
            name: "Home",
          });

          router.push({
            name: "StoreDetail",
            params: { storeid: storeID },
            query: { sessionId: params.get("sessionId") },
          });
        } else {
          let tmpUrl = new URL(url);
          let tmpPath = tmpUrl.pathname;

          const parts = tmpPath.split("/").filter(Boolean);

          if (
            parts[0] === "store-detail" &&
            parts[1] &&
            parts[2] === "my-deal"
          ) {
            setTimeout(() => {
              router
                .push({
                  name: "Home",
                })
                .then(() => {
                  router.push({ path: tmpPath });
                });
            }, 1000);
            return;
          }

          if (
            tmpPath &&
            (tmpPath == "/my-deals" ||
              (tmpPath.includes("store-detail") &&
                tmpPath.includes("deal-detail/store")))
          ) {
            setTimeout(() => {
              router
                .push({
                  name: "Home",
                })
                .then(() => {
                  router.push({ path: tmpPath });
                });
            }, 1000);
          }
        }
      } else {
        let splitUrl = url.split("/");
        if (!splitUrl[1]) reloadPage();
        router.push(splitUrl[splitUrl[splitUrl - 1]]);
      }
    } catch (error) {
      console.log("DeepLink Error", error);
    }
  };
});
